module.exports = __webpack_public_path__ + "img/mutibg.0090300f.png";